/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircle, Email, PhoneAndroid, QrCode2} from "@mui/icons-material";

const Formulario_Pedido = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                sx={{p: 1}}
            >


                <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: 'center'}}>
                    <IngresoTexto
                        Icono={QrCode2} nombre={'Numero del pedido'} dato={'numero'}   {...props}
                    />
                </Grid>




            </Grid>
        </form>

    )

}
export default Formulario_Pedido